import { Code } from 'react-bytesize-icons';
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import workerselection from "../../../../assets/images/docs/devtools/workerselection.png";
import * as React from 'react';
export default {
  Code,
  ShortCutDisplay,
  workerselection,
  React
};